import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Field } from "react-final-form";
import IdentifierIcon from "mdi-react/IdentifierIcon";
import FormTextboxIcon from "mdi-react/FormTextboxIcon";
import ImageFilterDramaIcon from "mdi-react/ImageFilterDramaIcon";
import ButtonContainer from "@components/ButtonContainer";
import FormTextField from "@components/Shared/FormTextField";
import IFormProps from "@interfaces/Shared/formProps";

const CreateClientForm = ({ handleSubmit }: IFormProps): ReactElement => {
  const { t } = useTranslation(["core"]);

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.name")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormTextboxIcon />
          </div>
          <Field
            name="name"
            component={FormTextField}
            type="text"
            placeholder={`${t("core:common.client")} ${t("core:common.name")}`}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.key")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <IdentifierIcon />
          </div>
          <Field
            name="key"
            component={FormTextField}
            type="text"
            placeholder="CLIENTKEY"
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("core:common.url_image")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <ImageFilterDramaIcon />
          </div>
          <Field
            name="logoUrl"
            component={FormTextField}
            type="text"
            placeholder="https://www.nftstudios.io/images/Avatar-Profile.png"
            isAboveError
          />
        </div>
      </div>

      <ButtonContainer />
    </form>
  );
};

export default CreateClientForm;
